import classNames from 'classnames';

export default function ModalInContainer({ ...props }) {
    return (
        <div
            className={classNames(
                `${props.className} absolute z-50 overflow-y-auto rounded-lg`
            )}
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
            style={{ display: props.open ? 'block' : 'none' }}
        >
            <div
                className="absolute text-center w-full"
                style={{
                    height: 'max-content',
                    background: 'rgb(48 52 52 / 60%)',
                }}
            >
                <div
                    className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-lg my-8"
                    style={{ width: props.width }}
                >
                    <div
                        className="modal-close cursor-pointer absolute top-4 right-4"
                        onClick={props.onCancel}
                    >
                        <svg
                            className="fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            style={{
                                fill: `${props?.values?.customizeStylePreference?.buttonThemeColor}`,
                            }}
                        >
                            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                        </svg>
                    </div>
                    <div
                        className={`bg-white ${
                            !props.isMobile ? 'p-4' : 'py-4'
                        }`}
                        style={props.style}
                    >
                        <div>
                            <div className="mt-3 text-center sm:mt-0 sm:text-left">
                                <h3
                                    className={`text-lg leading-6 font-medium text-gray-900 ${
                                        !props.isMobile ? 'px-4' : 'px-4 mb-3'
                                    }`}
                                    id="modal-title"
                                >
                                    {props.title}
                                </h3>
                                <p className="text-gray-300 text-sm w-full">
                                    {props.subTitle}
                                </p>
                                <div className="mt-2">{props.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
